import { Component, Input} from '@angular/core';
import { EmployeeCardStatus } from '../../models/EmployeeCard';

@Component({
    selector: 'app-employee-card-status',
    template: `
<span class="badge"
        [title]="description || ''"
        [class.help]="!!description"
        [class.text-bg-light]="value == 'Draft'"
        [class.text-bg-warning]="value == 'Submitted'"
        [class.text-bg-success]="value == 'Approved'"
        [class.text-bg-danger]="value == 'Rejected'"
        [class.text-bg-dark]="value == 'Revoked'">
    {{'employeeCard_status' + value | translate}}
</span>
`
})
export class EmployeeCardStatusComponent {
    @Input() value: EmployeeCardStatus;
    @Input() description: string;
}
